import React, { useContext, useState } from 'react'
import { BsCrop } from 'react-icons/bs'
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider';


const Transform = () => {

  const { textEditorOptions, setTextEditorOptions } = useContext(EditorContext);
  const [openTransform, setOpenTransform] = useState(false)

  const handleChange = (e) => {
    setTextEditorOptions({ ...textEditorOptions, angle: e.target.value });
  }

  return (
    <div className='editor-item transform'>
      <div className={`editor-icon ${openTransform ? 'active' : ''}`} onClick={e=> setOpenTransform(!openTransform)} data-toggle="tooltip" data-placement="top" title="Transform">
        <BsCrop />
      </div>
      <div className={`transform-body ${openTransform ? '' : 'd-none'}`}>
        <div className='input-field'>
          <input type="number" value={textEditorOptions.angle} onChange={handleChange} />
        </div>
        <div className='input-range'>
          <input type="range" class="custom-range" min={0} max={360} value={textEditorOptions.angle} onChange={handleChange} id="customRange1" />
        </div>
      </div>
    </div>
  )
}

export default Transform